import React from 'react';
import PropTypes from 'prop-types';
import IndoDate from '../../utils/IndoDate';

const DayView = ({ date, time, block }) => {
  const indoDate = time ? IndoDate(date, 'time') : IndoDate(date);
  const theDay = indoDate.split(',')[0];
  const theDate = indoDate.split(',')[1];
  const theTime = time ? indoDate.split(',')[2] : '';

  return (
    <div className="d-flex flex-column align-items-start">
      {block ? (
        <>
          <span>
            {theDay}, {theDate} {time ? `, ${theTime}` : ''}
          </span>
        </>
      ) : (
        <>
          <span>{theDay},</span>
          <span>
            {theDate} {time ? `, ${theTime}` : ''}
          </span>
        </>
      )}
    </div>
  );
};

DayView.propTypes = {
  date: PropTypes.string,
  time: PropTypes.bool,
  block: PropTypes.bool,
};

export default DayView;
